export default (color) => ({
    nm: 'loading_6',
    ddd: 0,
    h: 300,
    w: 300,
    meta: { g: '@lottiefiles/toolkit-js 0.26.1' },
    layers: [
        {
            ty: 4,
            nm: 'Shape Layer 2',
            sr: 1,
            st: 0,
            op: 300,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: { a: 0, k: [0, 0, 0], ix: 1 },
                s: { a: 0, k: [30.000000000000004, 30.000000000000004, 100], ix: 6 },
                sk: { a: 0, k: 0 },
                p: { a: 0, k: [150.00000000000003, 150.00000000000003, 0], ix: 2 },
                r: {
                    a: 1,
                    k: [
                        {
                            o: { x: 0.167, y: 0.167 },
                            i: { x: 0.833, y: 0.833 },
                            s: [0],
                            t: 0,
                        },
                        { s: [360], t: 60 },
                    ],
                    ix: 10,
                },
                sa: { a: 0, k: 0 },
                o: { a: 0, k: 100, ix: 11 },
            },
            ef: [],
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Ellipse 1',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'el',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Ellipse',
                            nm: 'Ellipse Path 1',
                            d: 1,
                            p: { a: 0, k: [0, 0], ix: 3 },
                            s: { a: 0, k: [300, 300], ix: 2 },
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 2,
                            lj: 1,
                            ml: 4,
                            o: { a: 0, k: 100, ix: 4 },
                            w: { a: 0, k: 50, ix: 5 },
                            c: { a: 0, k: color, ix: 3 },
                        },
                        {
                            ty: 'tr',
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            sk: { a: 0, k: 0, ix: 4 },
                            p: { a: 0, k: [0, 0], ix: 2 },
                            r: { a: 0, k: 0, ix: 6 },
                            sa: { a: 0, k: 0, ix: 5 },
                            o: { a: 0, k: 100, ix: 7 },
                        },
                    ],
                },
                {
                    ty: 'tm',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Filter - Trim',
                    nm: 'Trim Paths 1',
                    ix: 2,
                    e: {
                        a: 1,
                        k: [
                            { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [1], t: 0 },
                            { s: [100], t: 50 },
                        ],
                        ix: 2,
                    },
                    o: {
                        a: 1,
                        k: [
                            {
                                o: { x: 0.167, y: 0.167 },
                                i: { x: 0.833, y: 0.833 },
                                s: [0],
                                t: 0,
                            },
                            { s: [3], t: 60 },
                        ],
                        ix: 3,
                    },
                    s: {
                        a: 1,
                        k: [
                            { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0], t: 10 },
                            { s: [99], t: 60 },
                        ],
                        ix: 1,
                    },
                    m: 1,
                },
            ],
            ind: 1,
        },
        {
            ty: 4,
            nm: 'Shape Layer 1',
            sr: 1,
            st: 0,
            op: 300,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: { a: 0, k: [0, 0, 0], ix: 1 },
                s: { a: 0, k: [30.000000000000004, 30.000000000000004, 100], ix: 6 },
                sk: { a: 0, k: 0 },
                p: { a: 0, k: [150.00000000000003, 150.00000000000003, 0], ix: 2 },
                r: { a: 0, k: 0, ix: 10 },
                sa: { a: 0, k: 0 },
                o: { a: 0, k: 30, ix: 11 },
            },
            ef: [],
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Ellipse 1',
                    ix: 1,
                    cix: 2,
                    np: 3,
                    it: [
                        {
                            ty: 'el',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Ellipse',
                            nm: 'Ellipse Path 1',
                            d: 1,
                            p: { a: 0, k: [0, 0], ix: 3 },
                            s: { a: 0, k: [300, 300], ix: 2 },
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            o: { a: 0, k: 100, ix: 4 },
                            w: { a: 0, k: 50, ix: 5 },
                            c: { a: 0, k: [0.8549, 0.8431, 0.9725], ix: 3 },
                        },
                        {
                            ty: 'tr',
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            sk: { a: 0, k: 0, ix: 4 },
                            p: { a: 0, k: [0, 0], ix: 2 },
                            r: { a: 0, k: 0, ix: 6 },
                            sa: { a: 0, k: 0, ix: 5 },
                            o: { a: 0, k: 100, ix: 7 },
                        },
                    ],
                },
            ],
            ind: 2,
        },
    ],
    v: '5.8.1',
    fr: 30,
    op: 60,
    ip: 0,
    assets: [],
});
//# sourceMappingURL=LoadingSpinner.lottie.js.map